import type { ApiClient } from '@travel/api-client';
import env from '@travel/env';

import { isServer } from 'core/httpClient';
import type { ResponseBody } from 'Pitari-Types';

export const getPitari = async (http: ApiClient): Promise<ResponseBody> => {
  const pitariUrl = !isServer
    ? env('UNIVERSAL_PITARI_API_CLIENT_URL')
    : env('UNIVERSAL_PITARI_API_SERVER_URL');
  const url =
    env('UNIVERSAL_API_MOCK_SERVER') === 'true'
      ? env('UNIVERSAL_MOCK_PITARI_API_SERVER_URL')
      : pitariUrl;

  return http.get(url as string, {
    ignoreCommonErrorHandler: true,
    isThirdPartyApi: !isServer,
  });
};
